export const REFERRAL_OTHER_VALUE = "other";
export const REFERRAL_DETAIL_MAX_LENGTH = 120;

export const REFERRAL_SOURCES = [
	{ value: "instagram", label: "Instagram" },
	{ value: "tiktok", label: "TikTok" },
	{ value: "facebook", label: "Facebook" },
	{ value: "google_search", label: "Google / Search" },
	{ value: "friend_or_family", label: "Friend or Family" },
	{ value: "school", label: "School" },
	{ value: "event_or_convention", label: "Event or Convention" },
	{ value: REFERRAL_OTHER_VALUE, label: "Other" },
];

export const getReferralSourceLabel = (value) => REFERRAL_SOURCES.find((source) => source.value === value)?.label || value || "";

export const formatReferralForDisplay = (userData) => {
	if (userData?.referral?.label) {
		const { label, detail } = userData.referral;
		return detail ? `${label}: ${detail}` : label;
	}
	return userData?.referralPending ? "Not answered yet" : "";
};
